import React, { useState, useCallback } from 'react';
import { IconButton, List, ListItem, ListItemText, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'types/types';
import { setOpenedViews, updateDirtyState } from 'features/applicationState';
import Popup from 'components/Common/Popup';
import PopupActions from 'components/Common/PopupActions';
import { useBlocker} from 'react-router-dom';

export default function MaxOpenedViews() {
  const { openedViews, applicationSettings } = useSelector(
    (state: RootState) => state.applicationState
  );
  const maxOpendViews: number = Number.parseInt(
    applicationSettings.MAX_VIEWS_OPEN
  );
  const dispatch = useDispatch();
  const [openConfirmation, setOpenConfirmation] = useState(false);  // State to manage the confirmation dialog 
 
  const formDirtyState = useSelector(
    (state: RootState) => state.applicationState.formDirtyState
  );
  
  const blocker = useBlocker(({ nextLocation }) => {
    var dashboardId = nextLocation.pathname.split('/').pop() || '';  
    // check dirty form  
    if (formDirtyState){
      setOpenConfirmation(true);  // Show confirmation popup
      return true;  // Block navigation until user responds
    }  
    return (
      dashboardId?.indexOf('landing') < 0 &&
      openedViews.filter((_) => _.value != dashboardId).length >
        maxOpendViews - 1
    );
  });

  const onCloseClick = (view) => {
    const updatedOpenedViews = openedViews.filter((x) => x.value != view.value);
    dispatch(setOpenedViews(updatedOpenedViews));
    blocker.proceed?.();
  };

  const handleConfirm = useCallback(() => { 
    dispatch(updateDirtyState(false));
    setOpenConfirmation(false);  // Close the confirmation dialog
    blocker.proceed?.();  // Proceed with the navigation
  }, [dispatch, blocker]);

  const handleCancel = useCallback(() => {
    setOpenConfirmation(false);  // Close the confirmation dialog
    blocker.reset?.();  // Reset the blocker and stop navigation
  }, [blocker]);

  return (
    <>
      <Popup
        open={blocker.state === 'blocked' && openConfirmation == false}
        title="Max views selection reached"
        content={
          <div>
            <div>
              <p>The maximum number of views has been selected</p>
              <p>To open this view, please remove a selected view from the list below</p>
              <p>To go back to the previous view, please click close</p>
            </div>
            <div>
              <List className="list">
                {openedViews.map((view) => (
                  <ListItem key={view.value} className="item">
                    <ListItemText primary={view.text} className="text" />
                    <IconButton onClick={() => onCloseClick(view)}>
                      <CloseIcon className="close-icon" />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            </div>
          </div>
        }
        onClose={() => {
          blocker.reset?.();
        }}
        actions={
          <PopupActions
            handleCloseButtonClick={() => {
              blocker.reset?.();
            }}
          />
        }
      />

      {/* Confirmation dialog */}
      <Dialog open={openConfirmation} onClose={handleCancel}>
        <DialogTitle>{"Discard Changes"}</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to leave this page? <br/>Any unsaved changes might be lost</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} className="k-button k-button-icontext">
            <span>No</span>
          </Button>
          <Button onClick={handleConfirm} className="k-primary k-button k-button-icontext">
            <span>Yes</span>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
} 
